<template>
  <div class="print-data" style="page-break-after: always;">
    <div class="overflow-h mb20">
      <div class="fl" style="width: 400px;">
        <h1>No.{{print_data.out_bill_no}}</h1>
        <p>Invoice Date: {{print_data.date}}</p>
        <p>Account Number:</p>
        <p style="padding-left: 70px;">{{print_data.client_name_code}}</p>
      </div>
      <div class="fl">
        <h1>Bill&nbsp;To:</h1>
        <p>{{print_data.user_name}}</p>
        <p>{{print_data.email}}</p>
        <p>Phone: {{print_data.contact_phone}}</p>
      </div>
    </div>
    <table class="print-list">
      <tr>
        <th>收费项目</th>
        <th>单价</th>
        <th>数量</th>
        <th>费用</th>
        <th>最低收费</th>
        <th>小计</th>
      </tr>
      <tr v-for="(item,index) in print_data.fee_list" :key="index">
        <td>{{fee_type[item.fee_type]}}</td>
        <td>{{item.unit_price}}{{unit[item.unit]}}</td>
        <td>{{item.amount}}</td>
        <td>${{item.total_fee}}</td>
        <td>{{item.min_price}}</td>
        <td>${{item.total_fee}}</td>
      </tr>
    </table>
    <p class="totle">合计：${{print_data.total_fee}}</p>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        print_data:{},
        fee_type:{
          10: '包裹入仓费',
          20: '清理分拣费',
          30: '贴标费',
          40: '出库物料费',
          50: '出库打包费',
          60: '仓储费',
          70: '弃货处理',
        },
        unit:{
          10:'USD/KG',
          20:'USD/个',
          30:'USD/天/个',
        }
      }
    },
    created() {
      let print_data = localStorage.getItem('print_data')
      this.print_data = JSON.parse(print_data);
      setTimeout(()=>{
        window.print();
      },1000)
    }
  }
</script>

<style>
  .print-data{
    width: 900px;
    margin: 0px auto 0;
    font-size: 20px;
    padding-top: 20px;
  }
  h1{
    font-size: 24px;
  }
  .print-list tr,.print-list th{
    text-align: center;
    font-size: 18px;
  }
  .print-data .totle{
    margin: 20px 20px 0 0;
    text-align: right;
  }
</style>
<style media="print">
    @page {
      size: auto;  /* auto is the initial value */
      margin: 0mm; /* this affects the margin in the printer settings */
    }
</style>



// WEBPACK FOOTER //
// src/pages/zhongzhuanbuhuo/out/print.page.vue